import { useInternalInstance } from './useInstance';

export type Actions = ReturnType<typeof useActions>;

export const useActions = () => {
  const { actions } = useInternalInstance();
  return actions;
};
